import React from 'react';
import { Flex, Box } from '@chakra-ui/react';
import { Loading as Spinner } from '../components/lib/Loading';

export const Loading = () => {
    return (
        <Flex
            height="100vh"
            width="100vw"
            justify="center"
            align="center"
            flexDir="column">
            <Box>
                <Spinner isFullScreen text="Loading..." />
            </Box>
        </Flex>
    );
};
